import React from "react";
import ToolRow from "widgets/mtt-sustainability-tool/js/ToolRow";
import {inject} from "mt-react-decorators";

@inject(['manager', 'data_section'])
export default class ToolTextRow extends ToolRow.wrappedComponent {

    constructor(props){
        super(props);

        this.state = {
            text: '',
        };
    }

    getValue(input){
        return input.target.value;
    }

    componentDidMount(){

    }

    updateValue(input){
        this.setState({
            text: input.target.value,
        }, () => {
            super.updateValue(input);
        });
    }
    

    render() {
        return (
            <div className={'mtt-sustainability-tool__input-wrap'}>
                <div className={'mtt-sustainability-tool__input-wrap-header'}>{this.props.placeholder}</div>
                <div className={'mtt-sustainability-tool__input-wrap-content'}>
                    <textarea
                        onChange={input => this.updateValue(input)}
                    />
                    <div className={'hidden-textarea'}>{ this.state.text }</div>
                </div>
            </div>
        );
    }
}